import { BaseService } from '../../../core/services/BaseServices';

export class NewPortalService extends BaseService {
  constructor() {
    super('');
  }

  checkPortalCreationStatus = (executionName: string) => {
    return this.httpAxios
      .get(`system/checkPortalCreationStatus/${executionName}`, {})
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  createNewPortal = (params: any) => {
    return this.httpAxios
      .post('system/createPortal', params)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };
}

const newPortalService = new NewPortalService();

export default newPortalService;
